import { useEffect, useState } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { IoMdAddCircle } from "react-icons/io";
//import { Droppable, Draggable } from 'react-beautiful-dnd';
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import styles from "../styles/adminAppDisplaysComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";

import { AdminInstance } from "../utils/adminClass";
import { ImageInstance } from "../utils/imageClass";
import { ImageDraggableComponent } from "./imageDraggableComponent";

interface IFileWithPreview extends File {
  preview?: string;
}

interface IImage {
  id: string;
  imageUrl: string;
  createdAt: string;
  linkUrl?: string | null;
}

// Define the type for linkUrls
type LinkUrls = {
  [key: string]: string | null;
};

// // Define the type for the slots
// type CarouselSlots = {
//   slot1: IImage | null;
//   slot2: IImage | null;
//   slot3: IImage | null;
// };

type CarouselSlots = {
  [key: string]: IImage | null;
};

export const AdminAppDisplaysComponent = () => {
  //dummy placeholder for no image select matching IImage type
  const noImage = {
    id: "no-id",
    imageUrl: "no-image",
    createdAt: "not-today-satan",
    linkUrl: null,
  };

  //options for appLocation:
  const locationOptions = [
    "discover",
    "leaderboard",
    "experiences",
    "products",
    "venues",
    "brands",
    "budtenderWarsDispensary",
    "budtenderWarsBudtender",
  ];
  //location
  const [appLocation, setAppLocation] = useState("leaderboard");

  //selected image for upload
  const [currentImage, setCurrentImage] = useState<string | null>(null); //newly selected image to add to library
  const initialSlots = { slot1: null, slot2: null, slot3: null };
  const [carouselSlots, setCarouselSlots] = useState<CarouselSlots>(initialSlots);
  const [fileForUpload, setFileForUpload] = useState<File | null>(null);
  const [libraryImages, setLibraryImages] = useState<IImage[]>([]); //will be updated with images that have been saved and recently added with tempUrls so user can see instantly the image
  const [sideBoardImages, setSideBoardImages] = useState<IImage[]>([]); //will be updated with images that have been recently added with correct urls to swap in the tempUrls when sending to backend
  const [linkUrls, setLinkUrls] = useState<LinkUrls>({});

  //initialize our carousel and library
  useEffect(() => {
    fetchCarousel();
    fetchLibrary();
  }, [appLocation]);

  useEffect(() => {
    console.log("LINK URLS", linkUrls);
  }, [linkUrls]);

  const fetchCarousel = async () => {
    const carousel = await AdminInstance.getAppDisplay(appLocation, true);
    //formatting our returned carousel since it can return array size of 1, 2 or 3
    let threeSpotsCarousel = [...carousel];
    while (threeSpotsCarousel.length < 3) {
      threeSpotsCarousel.push(noImage);
    }
    if (threeSpotsCarousel.length === 3) {
      console.log("response", threeSpotsCarousel);
      setCarouselSlots({
        slot1: {
          id: threeSpotsCarousel[0].id,
          imageUrl: threeSpotsCarousel[0].imageUrl,
          createdAt: threeSpotsCarousel[0].createdAt,
          linkUrl: threeSpotsCarousel[0].linkUrl,
        },
        slot2: {
          id: threeSpotsCarousel[1].id,
          imageUrl: threeSpotsCarousel[1].imageUrl,
          createdAt: threeSpotsCarousel[1].createdAt,
          linkUrl: threeSpotsCarousel[1].linkUrl,
        },
        slot3: {
          id: threeSpotsCarousel[2].id,
          imageUrl: threeSpotsCarousel[2].imageUrl,
          createdAt: threeSpotsCarousel[2].createdAt,
          linkUrl: threeSpotsCarousel[2].linkUrl,
        },
      });
      setLinkUrls({
        slot1: threeSpotsCarousel[0].linkUrl,
        slot2: threeSpotsCarousel[1].linkUrl,
        slot3: threeSpotsCarousel[2].linkUrl,
      });
    } else {
      console.log("carousel returned is", carousel);
      console.log(`No carousel found for ${appLocation}`);
    }
  };

  const fetchLibrary = async () => {
    const library = await AdminInstance.getAppDisplay(appLocation, false);
    if (library) {
      setLibraryImages(library);
    } else {
      console.log(`No library found for ${appLocation}`);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [".jpg", ".jpeg", ".png"] },
    onDrop: (acceptedFiles: IFileWithPreview[]) => {
      // Add this line to create a preview URL
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      );

      const file: any = acceptedFiles[0];
      setFileForUpload(file);
      setCurrentImage(file.preview); // Ensure this uses the preview URL
    },
  });

  const onDragEnd = (result: any) => {
    const { source, destination } = result;

    if (!destination || source.droppableId !== "imageLibrary" || !destination.droppableId.startsWith("slot")) return;

    const itemToAdd = libraryImages[parseInt(source.index)];
    if (itemToAdd) {
      setCarouselSlots((prev) => ({
        ...prev,
        [destination.droppableId]: itemToAdd,
      }));
      //since we dragged it from libraryImages, remove it from the libraryImages array
      setLibraryImages((prev) => prev.filter((_, idx) => idx !== source.index));
    }
  };

  const resetSlot = (slotId: string) => {
    function isValidSlotId(key: any): key is keyof CarouselSlots {
      return ["slot1", "slot2", "slot3"].includes(key);
    }
    if (!isValidSlotId(slotId)) {
      console.log("not valid slot to reset");
      return;
    }
    const deactivatedImage = carouselSlots[slotId];
    if (deactivatedImage !== null) {
      if (deactivatedImage.id !== "no-id") {
        setLibraryImages((prevImages) => [...prevImages, deactivatedImage]);
      }
    }
    setCarouselSlots((prev) => ({
      ...prev,
      [slotId]: null,
    }));
    setLinkUrls((prev) => ({
      ...prev,
      [slotId]: null,
    }));
  };

  const noImageSlot = (slotId: string) => {
    function isValidSlotId(key: any): key is keyof CarouselSlots {
      return ["slot1", "slot2", "slot3"].includes(key);
    }
    if (!isValidSlotId(slotId)) {
      console.log("not valid slot to choose no image for");
      return;
    }
    const deactivatedImage = carouselSlots[slotId];
    if (deactivatedImage !== null) {
      setLibraryImages((prevImages) => [...prevImages, deactivatedImage]);
    }
    setCarouselSlots((prev) => ({
      ...prev,
      [slotId]: noImage,
    }));
  };

  const handleActiveUpdate = async () => {
    if (carouselSlots.slot1 === null || carouselSlots.slot2 === null || carouselSlots.slot3 === null) {
      return console.log("not all carousel images were selected");
    }
    const carouselImages = [carouselSlots.slot1, carouselSlots.slot2, carouselSlots.slot3];
    const carouselWithLinks = [
      { ...carouselSlots.slot1, linkUrl: linkUrls.slot1 },
      { ...carouselSlots.slot2, linkUrl: linkUrls.slot2 },
      { ...carouselSlots.slot3, linkUrl: linkUrls.slot3 },
    ];
    console.log("OUR CAROUSEL IMAGES IN ACTIVE UPDATE", carouselImages);
    // Map over carouselImages and replace with sideBoardImages if the id's match
    const noImageRemoved = carouselWithLinks.filter((slotImage) => slotImage.id !== "no-id");

    const imagesToUpdate = noImageRemoved.map((slotImage) => {
      const sideBoardImage = sideBoardImages.find((sideImage) => sideImage.id === slotImage.id);
      const linkUrl = linkUrls[slotImage.id] || slotImage.linkUrl;
      return sideBoardImage ? { ...sideBoardImage, linkUrl } : { ...slotImage, linkUrl };
    });

    console.log("SENDING OVER THIS FOR DB TO UPDATE ACTIVES", imagesToUpdate);
    const updated = await AdminInstance.updateAppDisplayActive(imagesToUpdate, appLocation);
    if (updated) {
      carouselSlots.slot1.imageUrl = updated[0]?.imageUrl;
      carouselSlots.slot2.imageUrl = updated[1]?.imageUrl;
      carouselSlots.slot3.imageUrl = updated[2]?.imageUrl;
      carouselSlots.slot1.linkUrl = updated[0]?.linkUrl;
      carouselSlots.slot2.linkUrl = updated[1]?.linkUrl;
      carouselSlots.slot3.linkUrl = updated[2]?.linkUrl;
      console.log(`${appLocation} is UPDATED`);
    } else {
      console.log(`no updates to carousel were made for ${appLocation}`);
    }
  };

  const handleImageUpload = async () => {
    if (!fileForUpload) return;

    try {
      const uploadResponse = await ImageInstance.uploadImageToS3(
        fileForUpload,
        "display-images",
        `${appLocation}-display-image`,
      );

      console.log("uploadResponse", uploadResponse);

      if (!uploadResponse) return;

      const newImage = await AdminInstance.addAppDisplayImage(uploadResponse.fileKey, appLocation);

      console.log("newImage", newImage);
      //actual image that we send to the db when we put the active images in order
      const newImg: IImage = {
        id: newImage.data.id,
        imageUrl: newImage.data.imageUrl,
        createdAt: newImage.data.createdAt,
        linkUrl: null,
      };

      //uses currentImage so the local link shows the image
      const tempImg: IImage = {
        id: newImage.data.id,
        imageUrl: currentImage ? currentImage : newImage.data.imageUrl,
        createdAt: newImage.data.createdAt,
        linkUrl: null,
      };

      if (newImage && newImage.data.imageUrl) {
        setSideBoardImages([...sideBoardImages, newImg]); //for swapping on submit
        setLibraryImages([...libraryImages, tempImg]); //add to our drag and drop library visually on page
        setCurrentImage(null); // reset the displayed image preview
        console.log("Library ARR NEW SIZE", libraryImages.length);
        setFileForUpload(null); // Reset the fileForUpload state
      }
    } catch (error) {
      console.error("Error uploading image: ", error);
    }
  };

  const handleDeleteImage = async (imageId: string) => {
    try {
      await AdminInstance.deleteAppDisplayImage(imageId, appLocation); // Replace with your actual deletion API call
      // Filter out the deleted image from libraryImages
      setLibraryImages((prevImages) => prevImages.filter((img) => img.id !== imageId));
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const renderSlots = () => {
    const handleLinkChange = (slotId: keyof CarouselSlots, newLink: string) => {
      console.log("in handle link change", slotId, newLink);
      setLinkUrls((prev) => ({ ...prev, [slotId]: newLink }));
    };

    return (
      <>
        {Object.entries(carouselSlots).map(([slotId, img], index) => (
          <Col key={slotId}>
            <Droppable droppableId={slotId} isDropDisabled={!!img}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ height: 300 }}
                  className="rounded mb-3 dropzone mw-100 h-250 d-flex justify-content-center align-items-center border border-solid"
                >
                  {img ? (
                    img.id === "no-id" ? (
                      <p>Selected No Image</p>
                    ) : (
                      <ImageDraggableComponent
                        img={img}
                        index={index}
                        draggableType="carousel"
                        handleDelete={() => {}}
                      />
                    )
                  ) : (
                    <div className="flex-column d-flex align-items-center">
                      <p>Drop image for slot {index + 1} here</p>
                      <p>OR</p>
                      <Button className="btn btn-primary" disabled={!!img} onClick={() => noImageSlot(slotId)}>
                        Choose no image for slot {index + 1}
                      </Button>
                    </div>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            {img?.id !== "no-id" && (
              <div className="d-flex justify-content-center align-items-center mt-2">
                <span className="me-2">Link: </span>
                <input
                  className="flex-grow-1"
                  type="text"
                  placeholder="Enter link URL"
                  value={linkUrls[slotId] ?? carouselSlots[slotId]?.linkUrl ?? ""}
                  onChange={(e) => handleLinkChange(slotId, e.target.value)}
                />
              </div>
            )}
            <div className="d-flex justify-content-center mt-3">
              <Button className="btn btn-primary" disabled={!img} onClick={() => resetSlot(slotId)}>
                Reset slot {index + 1}
              </Button>
            </div>
          </Col>
        ))}
      </>
    );
  };

  const upperCaser = (word: string) => {
    if (word === "budtenderWarsDispensary") {
      return "Budtender Wars - Dispensary";
    } else if (word === "budtenderWarsBudtender") {
      return "Budtender Wars - Budtenders";
    } else {
      return word[0].toUpperCase() + word.slice(1);
    }
  };

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col>
          <h2>{upperCaser(appLocation)} Display Images</h2>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mb-4">
        <Col className="d-flex justify-content-start align-items-center">
          <h3 className="me-2 mb-0">Carousel for:</h3>
          <div className={styles.searchFilterWrapper}>
            <select className="form-select" value={appLocation} onChange={(e) => setAppLocation(e.target.value)}>
              {locationOptions.map((spot, index) => (
                <option key={index} value={spot}>
                  {upperCaser(spot)}
                </option>
              ))}
            </select>
          </div>
        </Col>
      </Row>

      <Row>
        <DragDropContext onDragEnd={onDragEnd}>
          {/* Carousel Droppable */}
          <Row className="mb-3" style={{ margin: 0, padding: 0 }}>
            {renderSlots()}
          </Row>
          <Col>
            <Row className="mb-3 px-3">
              <Button
                className={btnStyles.Basic}
                disabled={carouselSlots.slot1 === null || carouselSlots.slot2 === null || carouselSlots.slot3 === null}
                variant="primary"
                onClick={handleActiveUpdate}
              >
                Update Carousel
              </Button>
            </Row>
          </Col>
          {/* Image Library Droppable */}
          {/* Disable dropping back into the library for simplicity */}
          <Droppable key="imageLibrary" droppableId="imageLibrary" isDropDisabled={true}>
            {(provided, snapshot) => {
              return (
                <Row>
                  <Col className="mb-3">
                    <h3>{upperCaser(appLocation)} Image Library</h3>
                  </Col>
                  <div ref={provided.innerRef} {...provided.droppableProps} className={styles.imageLibraryContainer}>
                    {libraryImages.map((img: any, index: any) => (
                      <ImageDraggableComponent
                        img={img}
                        index={index}
                        draggableType="library"
                        handleDelete={handleDeleteImage}
                      />
                    ))}
                    {provided.placeholder}
                  </div>
                </Row>
              );
            }}
          </Droppable>
        </DragDropContext>
      </Row>
      <Row className="mb-3"></Row>
      <Col className="mb-3">
        <h3>Add Image to Library</h3>
      </Col>
      <Row className="mb-3">
        <Col xs={12} md={6}>
          <div
            {...getRootProps({
              className: "dropzone border border-dashed p-5 d-flex justify-content-center align-items-center",
            })}
          >
            <input {...getInputProps()} />
            <p>Drag 'n' drop your image here, or click to select files</p>
            <IoMdAddCircle size="25px" />
          </div>
          <div className="justify-content-center align-items-center p-5 d-flex">
            <Button className={btnStyles.Basic} disabled={!fileForUpload} variant="primary" onClick={handleImageUpload}>
              Add Image
            </Button>
          </div>
        </Col>
        <Col xs={12} md={6}>
          {currentImage && (
            <div>
              <Image src={currentImage} alt={"selected image image to add"} thumbnail />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};
